import React from "react"
import { TextField, IconButton, InputAdornment } from "@mui/material"
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material"

interface SearchTextFieldProps {
  value: string
  onChange: (value: string) => void
  onClear: () => void
}

const SearchTextField: React.FC<SearchTextFieldProps> = ({ value, onChange, onClear }) => {
  return (
    <TextField
      placeholder="Search"
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value ? (
              <IconButton size="small" onClick={onClear}>
                <ClearIcon />
              </IconButton>
            ) : (
              <SearchIcon />
            )}
          </InputAdornment>
        )
      }}
      sx={{ minWidth: "200px" }}
    />
  )
}

export default SearchTextField 